export class AzureVmNativeRestoreTarget {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "restoreAccountId",
            "baseName": "restoreAccountId",
            "type": "string",
            "format": ""
        },
        {
            "name": "resourceGroupName",
            "baseName": "resourceGroupName",
            "type": "string",
            "format": ""
        },
        {
            "name": "vmName",
            "baseName": "vmName",
            "type": "string",
            "format": ""
        },
        {
            "name": "virtualNetworkName",
            "baseName": "virtualNetworkName",
            "type": "string",
            "format": ""
        },
        {
            "name": "subnetName",
            "baseName": "subnetName",
            "type": "string",
            "format": ""
        },
        {
            "name": "availabilityZone",
            "baseName": "availabilityZone",
            "type": "AzureVmNativeRestoreTargetAvailabilityZoneEnum",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AzureVmNativeRestoreTarget.attributeTypeMap;
    }
    constructor() {
    }
}
export var AzureVmNativeRestoreTargetAvailabilityZoneEnum;
(function (AzureVmNativeRestoreTargetAvailabilityZoneEnum) {
    AzureVmNativeRestoreTargetAvailabilityZoneEnum["_1"] = "1";
    AzureVmNativeRestoreTargetAvailabilityZoneEnum["_2"] = "2";
    AzureVmNativeRestoreTargetAvailabilityZoneEnum["_3"] = "3";
})(AzureVmNativeRestoreTargetAvailabilityZoneEnum || (AzureVmNativeRestoreTargetAvailabilityZoneEnum = {}));
